import React, { useState, useEffect } from 'react';
import Card from '../../../../components/Card';
import TeacherSearchBar from '../../../../components/TeacherSearchBar';
import styles from './TeacherInformation.module.sass';
import { getUser } from '../../../../services/user.service';

const TeacherInformation = ({ sessionData, onInputChange }) => {
    const [currentTeacher, setCurrentTeacher] = useState(null);
    const [loading, setLoading] = useState(false);

    // Charger les informations du formateur actuel
    useEffect(() => {
        const fetchCurrentTeacher = async () => {
            if (sessionData.teacher_id) {
                try {
                    setLoading(true);
                    const teacher = await getUser(sessionData.teacher_id);
                    setCurrentTeacher(teacher);
                } catch (error) {
                    console.error('Erreur lors de la récupération du formateur:', error);
                    setCurrentTeacher(null);
                } finally {
                    setLoading(false);
                }
            } else {
                setCurrentTeacher(null);
            }
        };

        fetchCurrentTeacher();
    }, [sessionData.teacher_id]);

    const handleSelectTeacher = (teacher) => {
        if (teacher) {
            onInputChange('teacher_id', teacher.id);
            setCurrentTeacher(teacher);
        } else {
            onInputChange('teacher_id', '');
            setCurrentTeacher(null);
        }
    };

    return (
        <Card
            className={styles.card}
            title="Intervenant"
            classTitle="title-blue"
        >
            <div className={styles.field}>
                <TeacherSearchBar
                    label="Sélectionner un formateur"
                    placeholder="Rechercher par nom ou prénom"
                    onSelectTeacher={handleSelectTeacher}
                    selectedTeacher={currentTeacher}
                    required
                />
            </div>
            
            {loading && (
                <div className={styles.loading}>Chargement des informations du formateur...</div>
            )}
        </Card>
    );
};

export default TeacherInformation;